import { StrapiID } from './common'
import { RemoteImage } from './image'
import { Requirements } from './requirements'

export type AttributeConfig = {
  id: StrapiID
  name: string
  icon?: RemoteImage
  image?: RemoteImage
}

export type AttributeRelation = {
  id: StrapiID
  requires?: Requirements
}
